<div fxFlex="1 1 auto" fxFlex.xs="1 1" fxLayout="column" class="playlist-panel">
	<div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="25px">
		<div fxLayout="row" fxFlex="1 1" fxLayoutAlign="start center" fxLayoutGap="5px" fxLayoutGap.xs="4px">
			<mat-icon class="playlist-icon" svgIcon="playlist"></mat-icon>
			<p class="playlist-title">{{title}}</p>
		</div>
		<div fxLayout="row" fxFlex="0 0" fxLayoutAlign="center stretch" fxLayoutGap="8px" fxLayoutGap.xs="3px">
			<div class="progress-info" fxFlex="1 0 20" fxLayoutAlign="center center">
				<mat-progress-bar class="prog-br" [value]="progressCount" color="primary" mode="determinate">
				</mat-progress-bar>
			</div>
			<button mat-icon-button (click)="showQueues = !showQueues">
				<mat-icon class="drop-icon">{{(showQueues) ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
			</button>
			<mat-divider [vertical]="'true'" fxHide.xs></mat-divider>
		</div>
	</div>
	<div [ngClass]="{'show': showQueues}" class="queues">
		<app-playlist-queue [playList]="playlistData" (emitData)="getPlayList($event)">
		</app-playlist-queue>
	</div>
</div>
